import { IntercomUserUpdateOptions } from '@capacitor-community/intercom';
import { Intercom as IntercomInterface } from './intercom';

/**
 * Intercom JS API: https://developers.intercom.com/installing-intercom/docs/intercom-javascript
 */
export class IntercomWeb implements IntercomInterface {
  boot() {
    // Nothing until we decide what we show in webapp
  }

  booted() {
    // Nothing until we decide what we show in webapp
    return false;
  }

  setUser(data: { userId: string; email: string }) {
    // Nothing until we decide what we show in webapp
  }

  updateUser(data: IntercomUserUpdateOptions): void {
    // Nothing until we decide what we show in webapp
  }

  open() {
    // Nothing until we decide what we show in webapp
  }

  logout() {
    // Nothing until we decide what we show in webapp
  }
}
